import * as React from 'react'
import { Link } from 'widgets-for-react'
import { ButtonPrimary, StartTrialButton } from '../../../utils/buttons'
import { InView } from 'react-intersection-observer'
import { blockInviewHandler } from '../../../utils/inview'
import i18next from 'i18next'
import { routeUpdaters } from '../routes/routesState'
import { DataLayer, PIIData } from '../../../utils/datalayer'

type PaywallProps = { hasFade: boolean, piiData?: PIIData }

export const PaywallLayout = {
  Register: (p: PaywallProps) => (
    <InView
      as="section"
      threshold={0}
      triggerOnce={true}
      onChange={(isInView, entry) => blockInviewHandler(isInView, entry.target)}
      role="alert"
      className={`paywall paywall--register${
        p.hasFade ? ' paywall--fade' : ''
      }`}
    >
      <div className="paywall__inner bg--secondary">
        <div className="paywall__container container--m gutter--m">
          <div className="paywall__content">
            <header className="paywall__header">
              <p className="paywall__title title--m">
                <span
                  dangerouslySetInnerHTML={{
                    __html: i18next.t('paywall:paywallRegisterTitleA'),
                  }}
                />
                <span
                  dangerouslySetInnerHTML={{
                    __html: i18next.t('paywall:paywallRegisterTitleB'),
                  }}
                />
              </p>
            </header>
            <div className="paywall__intro">
              <ul className="list--hexagon">
                <li className="list__item">
                  <p className="list__text">
                    {i18next.t('paywall:paywallRegisterListPrimary')}
                  </p>
                </li>
                <li className="list__item">
                  <p className="list__text">
                    {i18next.t('paywall:paywallRegisterListSecondary')}
                  </p>
                </li>
                <li className="list__item">
                  <p className="list__text">
                    {i18next.t('paywall:paywallRegisterListTertiary')}
                  </p>
                </li>
              </ul>
            </div>
            <footer className="paywall__footer block__clickables">
              <div className="block__clickable">
                <StartTrialButton extraClasses="paywall__button" />
              </div>
              <div className="block__clickable">
                <p className="text--s text--styled">
                  {i18next.t('paywall:paywallRegisterFooterA')}{' '}
                  <Link to={routeUpdaters(i18next.language).login.url + `?originPath=${window.location.pathname}`}>
                    {i18next.t('paywall:paywallRegisterFooterB')}
                  </Link>
                </p>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </InView>
  ),
  Subscribe: (p: PaywallProps) => (
    <InView
      as="section"
      threshold={0}
      triggerOnce={true}
      onChange={(isInView, entry) => blockInviewHandler(isInView, entry.target)}
      role="alert"
      className={`paywall paywall--subscribe${
        p.hasFade ? ' paywall--fade' : ''
      }`}
    >
      <div className="paywall__inner bg--secondary">
        <div className="paywall__container container--m gutter--m">
          <div className="paywall__content">
            <header className="paywall__header">
              <p className="paywall__title title--m">
                <span
                  dangerouslySetInnerHTML={{
                    __html: i18next.t('paywall:paywallSubscribeTitleA'),
                  }}
                />
                <span
                  dangerouslySetInnerHTML={{
                    __html: i18next.t('paywall:paywallSubscribeTitleB'),
                  }}
                />
              </p>
            </header>
            <p className="paywall__intro">
              {i18next.t('paywall:paywallSubscribeText')}
            </p>
            <ButtonPrimary
              kind="link"
              to={routeUpdaters(i18next.language).upgrade.url}
              size="m"
              label={i18next.t('paywall:paywallSubscribeButton')}
              onClick={() => DataLayer.initiateCheckOut(p.piiData)}
              extraClasses="paywall__button"
            />
          </div>
        </div>
      </div>
    </InView>
  ),
}

export const PreFooterCtaLayout = {
  Register: () => (
    <InView
      as="section"
      threshold={0}
      triggerOnce={true}
      onChange={(isInView, entry) => blockInviewHandler(isInView, entry.target)}
      className="block block--cta-footer bg--secondary"
    >
      <div className="block__inner container--m gutter--m">
        <div
          className="block__content title--m"
          dangerouslySetInnerHTML={{
            __html: i18next.t('footer:preFooterCtaStartTrial'),
          }}
        />
        <footer className="block__footer">
          <StartTrialButton />
        </footer>
      </div>
    </InView>
  ),

  Subscribe: () => (
    <InView
      as="section"
      threshold={0}
      triggerOnce={true}
      onChange={(isInView, entry) => blockInviewHandler(isInView, entry.target)}
      className="block block--cta-footer bg--secondary"
    >
      <div className="block__inner container--m gutter--m">
        <div
          className="block__content title--m"
          dangerouslySetInnerHTML={{
            __html: i18next.t('footer:preFooterCtaTrialToPro'),
          }}
        />
        <footer className="block__footer">
          <ButtonPrimary
            size="m"
            kind="link"
            to={routeUpdaters(i18next.language).upgrade.url}
            label={i18next.t('subscription:upgradeAccount')}
            onClick={() =>
              DataLayer.headerButtonsClick(
                i18next.t('subscription:upgradeAccount')
              )
            }
          />
        </footer>
      </div>
    </InView>
  ),
}
